/** @jsx jsx */

import React from "react";
import { jsx } from "@emotion/core";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import storeConfig from "./reducers/store";
import Router from "./routes";

const { store, persistor } = storeConfig;

// persistor.purge();

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router />
      </PersistGate>
    </Provider>
  );
};

export default App;
